@use '~/theme/theme' as *;

.resumeRow {
  align-items: center;
  column-gap: spacing(1);
  padding-left: 24px;
  padding-right: 24px;
  padding-block: 8px;
}

.rowSelected {
  background-color: color(violet-100);
}

.resumeShowPlainRow {
  display: grid;
  grid-template-columns: 24px 120px auto 126px;
  height: 56px;
}

.resumeDissociatingRow {
  display: grid;
  grid-template-columns: 24px 120px auto 100px;
  height: 56px;
}

.resumeShowSplitRow {
  background-color: color(grey-100);
  display: grid;
  grid-template-columns: 24px 120px 3fr 85px 90px;

  .rowDivider {
    grid-column: 1 / -1;
    height: spacing(3);
  }

  .gridColumn {
    &1_4 {
      grid-column: 1 / 4;
    }

    &1_3 {
      grid-column: 1 / 3;
    }
  }
}

.resumeSplittingRow {
  display: grid;
  grid-template-columns: 24px 120px 215px 1fr 100px;
  height: 56px;
}

.removeIdle {
  display: flex;
  gap: spacing(1);
  align-items: center;
}

.documentResumeContainer {
  border: 0 solid color(grey-300);
  border-bottom-width: 1px;
  background: color(grey-100);
  padding: spacing(2) spacing(2.5);
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  gap: spacing(1);
}

.documentResumeText {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: hidden;
  gap: spacing(1);
}

.resultContainer {
  border-radius: 8px;
  border: 1px solid color(grey-300);
  background: white;
  overflow: hidden;
  flex-shrink: 0;
}

.documentResumeCategory {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: spacing(1);
  flex: 1 0;
  align-items: end;
}

.documentStatus {
  display: flex;
  align-self: start;
}

.reconciliatedFlowDescription {
  display: flex;
  gap: spacing(1);
  align-items: center;
}

.controlContainer {
  display: flex;
  justify-content: end;
}

.stack {
  display: flex;
  flex-direction: column;
}

.amountContainer {
  display: flex;
  gap: spacing(1);
  justify-content: end;
  align-items: center;
}

.splittingForm {
  display: flex;
  gap: spacing(1);
  align-items: center;
  justify-content: end;
}

.tooltip {
  display: flex;
  flex-direction: column;
  gap: spacing(2);
}

.dissociationFeedback {
  display: flex;
  justify-content: center;
  margin: spacing(1) 0;

  > * {
    flex-grow: initial;
  }
}
